export default __webpack_public_path__ + "static/media/oneLegJump_thumb.a2f0e9ea.png";